// All faqs related apis
import { API_URL } from "./api";
import instance from "./api";

// Get api for fetching all active faqs with support of filter with search keyword
export const fetchFaqs = async (keyword) => {
  return await instance.get(`${API_URL}/faqs?keyword=${keyword}`);
};
